const SHOPIFY_DOMAIN = '462f01-b4.myshopify.com';
const SHOPIFY_STOREFRONT_ACCESS_TOKEN = 'aabf66abf27a4e88d5c46f1680011718';
const SHOPIFY_GRAPHQL_API_URL = 'https://' + SHOPIFY_DOMAIN + '/api/2026-01/graphql.json';
const SHOPIFY_GRAPHQL_API_MAX_RETRY = 2;
const SHOPIFY_GRAPHQL_COLLECTION_PREFIX = 'gid://shopify/Collection/';
const SHOPIFY_GRAPHQL_PRODUCT_PREFIX = 'gid://shopify/Product/';
const SHOPIFY_GRAPHQL_PRODUCT_VARIANT_PREFIX = 'gid://shopify/ProductVariant/';
const SHOPIFY_ASSETS_BASE_URL = _shopifyUrlImagesBase;
const SHOPIFY_ABAT_JOUR_DEFAUT_PRODUIT_ID = 9677776060717;
const SHOPIFY_SOCLES_COLLECTION_ID = 513319895341;
const SHOPIFY_POIGNEES_COLLECTION_ID = 510288036141;
const SHOPIFY_AMPOULES_COLLECTION_ID = 510330929453;


document.addEventListener('contextmenu', event => {
    event.preventDefault();
});